import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom/client';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css";
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { LicenseManager } from "ag-grid-enterprise";
import { AccountInfo, AuthenticationResult, Configuration, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { _clientSettings } from './config/client-settings';

LicenseManager.setLicenseKey("CompanyName=Bulgari SPA,LicensedGroup=Bulgari-IT,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-008270,ExpiryDate=26_May_2023_[v2]_MTY4NTA1NTYwMDAwMA==88979d702735cc308249f02ab81e588e");

const baseUrl: string = document.getElementsByTagName('base')[0].getAttribute('href');

const msalConfig: Configuration = {
    auth: {
        clientId: _clientSettings.clientId,
        authority: _clientSettings.authority,
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: false
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload: AuthenticationResult = event.payload as AuthenticationResult;
        const account: AccountInfo = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0)
    msalInstance.setActiveAccount(accounts[0]);

ReactDOM
.createRoot(document.getElementById('root'))
.render(
    <React.StrictMode>
        <App
            baseUrl={baseUrl}
            msalInstance={msalInstance}
            isAccountLogged={accounts.length > 0}
        />
    </React.StrictMode>
);

// Disable service worker on production
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator)
    unregister();
else
    registerServiceWorker();